// Dependencies
import React from 'react';
import { AnimatePresence } from 'framer-motion';

// Components
import Scripts from './src/components/scripts/scripts';

// Utilities
import {
  callingCardConsoleBody,
  callingCardConsoleTitle,
} from './src/utilities/callingCard';

// Contexts
import { MenuContextProvider } from './src/contexts/menu';

// Leave calling card in console
console.log(
  `%c${callingCardConsoleTitle}%c\n${callingCardConsoleBody}`,
  'font-weight: 700; font-size: 13px; color: #5e29d6;',
  'font-weight: 400; font-size: 12px; color: inherit;',
);

export const wrapRootElement = ({ element }) => (
  <MenuContextProvider>{element}</MenuContextProvider>
);

export const wrapPageElement = ({ element }) => (
  <>
    <AnimatePresence mode="wait">{element}</AnimatePresence>

    <Scripts />
  </>
);
